import React from 'react';
import { useClientStore } from 'apps/hooks';
import { observer } from 'mobx-react';
import { MenuItem, Avatar, Box } from 'components';

// TODO (david): This is a subset of what will be a proper typing that will be used in SpaceModel
type Content = {
  avatar?: {
    id: string;
    url: string;
  };
  title: string;
  slug: string;
  inSpace: Workspace;
};

type Workspace = {
  id: string;
  parent?: Workspace;
  content: Content;
  spaceType: 'PROFILE' | 'INITIATIVE' | 'GLOBAL';
  path: string;
};

const WorkspaceSwitcherMenuItems = observer(() => {
  const clientStore = useClientStore();
  const { activeSpace } = clientStore;

  const workspaces: Workspace[] = clientStore.workspaces
    .slice()
    .sort((a: Workspace, b: Workspace) => {
      if (a.id === activeSpace?.id) return -1;
      if (b.id === activeSpace?.id) return 1;
      return 0;
    });

  return (
    <>
      {workspaces.map(workspace => {
        const isSelected = activeSpace?.id === workspace.id;
        const handleClick = () => {
          clientStore.SetActiveWorkspace(workspace.id);
          clientStore.MaybeNavigateToTheDefaultSpaceRoute();
        };

        let text = workspace.content.title;
        let avatarName = workspace.content.slug;
        if (workspace.spaceType === 'INITIATIVE') {
          avatarName = text;
        }

        if (workspace.spaceType === 'PROFILE')
          text = `@${workspace.content.slug}`;

        return (
          <MenuItem
            key={workspace.id}
            selected={isSelected}
            onClick={handleClick}
          >
            <Box mr={2}>
              <Avatar
                src={workspace.content.avatar?.url}
                name={avatarName}
                selected={isSelected}
              />
            </Box>
            {text}
          </MenuItem>
        );
      })}
    </>
  );
});

export default WorkspaceSwitcherMenuItems;
